module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_04A.37d3b1bb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_04A.mp3
// module id = 115
// module chunks = 0